<template>
    <div class="homecarousel">
      <h1 v-if="loading">
            <font-awesome-icon :icon="['fas', 'circle-notch']" class="fa-spin"/>
      </h1>
<b-carousel id="carousel1"
                style="text-shadow: 1px 1px 2px #333;"
                controls
                indicators
                background="#ababab"
                :interval="4000"
                img-width="1024"
                img-height="480"
                v-model="slide"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
                v-if="!loading"
    >
      <b-carousel-slide v-for="content in contents" :key="content.contentId" v-if="content"
                        :caption="content.title"
                        :text="content.text"
                        :img-src="content.graphic">
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      slide: 0,
      sliding: null,
      contents: [],
      loading: true
    }
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    getContents: function (id) {
      axios.get('http://bargoapi.finitegames.com/api/finitegames/getCarouselContent')
        .then((response) => {
          this.contents = response.data.Contents
          this.loading = false
        }, (error) => {
          console.log(error)
          this.loading = false
        })
    }
  },
  beforeMount () {
    this.getContents()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HomeCarousel.vue